import { Button, Typography } from 'antd'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import CommonModal from 'src/app/shared/components/modal/common-modal'
import { colorBorder } from 'src/app/themes/primaryThemeDefault'
import { IViewAccount } from 'src/app/shared/models/clientSetup.model'
import './index.scss'
import NewCommonTable from 'src/app/shared/components/common/new-table'
import { TableColumnDefs } from 'src/app/shared/components/common/new-table/table.model'

interface ViewUsersModalProps {
  isOpen: boolean
  onClose: () => void
  listUser?: IViewAccount[]
  userRole?: string
}

const ViewUsersModal: React.FC<ViewUsersModalProps> = ({ isOpen, onClose, listUser, userRole }) => {
  const { t } = useTranslation()
  const getHeaderName = useCallback(
    (field: string): string => {
      return t(`UserRoles:rolesByUserList.${field}`)
    },
    [t],
  )

  const generateCustomColumnDefs = useCallback((): Array<TableColumnDefs> => {
    return [
      {
        colId: 'no',
        field: 'no',
        width: 52,
        headerName: t(getHeaderName('no')),
        cellRenderer: (params: any) => {
          return params.node.rowIndex + 1
        },
        sortable: false,
        resizable: false,
        hide: false,
        defaultSelect: true,
      },
      {
        colId: 'lastName',
        field: 'lastName',
        headerName: t(getHeaderName('lastName')),
        sortable: false,
        resizable: false,
        minWidth: 193,
        defaultSelect: true,
      },
      {
        colId: 'firstName',
        field: 'firstName',
        headerName: t(getHeaderName('firstName')),
        sortable: false,
        resizable: false,
        minWidth: 193,
        defaultSelect: true,
      },
      {
        colId: 'userName',
        field: 'userName',
        headerName: t(getHeaderName('userName')),
        sortable: false,
        resizable: false,
        minWidth: 193,
        defaultSelect: true,
      },
    ]
  }, [getHeaderName, t])

  return (
    <CommonModal
      title={t('UserRoles:viewUserRole.viewTitle', {
        userRole,
      })}
      width={708}
      size='middle'
      open={isOpen}
      onClose={onClose}
      footer={[
        <Button
          key='cancel-btn'
          style={{
            fontWeight: 600,
            width: '102px',
            height: '32px',
            border: `1px solid ${colorBorder}`,
          }}
          onClick={onClose}
        >
          <Typography.Text>{t('UserRoles:close')}</Typography.Text>
        </Button>,
      ]}
    >
      <div className='table-user-role'>
        <NewCommonTable
          rowData={listUser}
          displayAddBtn={false}
          displayUploadButton={false}
          handleSearch={async () => await {}}
          disableTableControl={true}
          displayActionColumn={false}
          translationNamespace='UserRoles:rolesByUserList'
          generateCustomColumnDefs={generateCustomColumnDefs}
        />
      </div>
    </CommonModal>
  )
}

export default ViewUsersModal
